<script setup lang="ts">

import ButtonInput from "@/components/inputs/Button.vue";
import Translator from '@/utils/common/Translator'
import {ref} from "vue";
import {useErrorsStore} from "@/stores/ToastDataStore.ts";
import type {QInput} from "quasar";
import NamaIcon from "@/components/icons/NamaIcon.vue";

const props = defineProps<{ urlToken?: string}>();

const token = ref(props.urlToken ?? "");
const password = ref("");
const canShowPassword = ref(false);
const reTypePassword = ref("");
const reTypePasswordValidationError = ref<string>("");
const tokenRef = ref<QInput>();
const passwordRef = ref<QInput>();
const reTypePasswordRef = ref<QInput>();
const emit = defineEmits(['confirmChangePassword']);


function onContinueClick() {
  if (!validateConfirmPassword())
    return;
  emit('confirmChangePassword', password.value, reTypePassword.value, token.value);
}

function validateConfirmPassword() {
  if (password.value && reTypePassword.value && password.value === reTypePassword.value)
    return true;
  useErrorsStore().pushErrorStr(Translator.translateId("passwordsDoNotMatch"));
  return false;
}

function onEnterDown() {
  if (!token.value) {
    tokenRef.value?.focus();
  } else if (!password.value) {
    passwordRef.value?.focus();
  } else if (!reTypePassword.value) {
    reTypePasswordRef.value?.focus();
  } else {
    onContinueClick();
  }
}
</script>

<template>
  <div class="tw-flex tw-flex-1 tw-items-center tw-justify-center tw-px-6 tw-py-10 mobile:tw-px-5 mobile:tw-py-8">
    <div class="tw-w-full tw-max-w-[380px]">
      <h2 class="tw-m-0 tw-text-3xl tw-font-medium tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark mobile:tw-text-2xl"
          v-text="Translator.translateId('resetPassword')"/>
      <div class="tw-mb-7"></div>
      <q-input
        input-class="nama-input-class"
        outlined
        dense
        class="nama-auth-input nama-focused-input nama-field-input tw-mb-4"
        v-model="token"
        :placeholder="Translator.translateId('resetToken')"
        :hide-bottom-space="true"
        @keyup.enter="onEnterDown"
        ref="tokenRef">
        <template v-slot:prepend>
          <NamaIcon default-icon="nm-user"/>
        </template>
      </q-input>
      <q-input
        input-class="nama-input-class"
        outlined
        dense
        class="nama-auth-input nama-focused-input nama-field-input tw-mb-4"
        v-model="password"
        :type="canShowPassword?'text':'password'"
        :placeholder="Translator.translateId('newPassword')"
        :hide-bottom-space="true"
        @keyup.enter="onEnterDown"
        ref="passwordRef">
        <template v-slot:prepend>
          <NamaIcon default-icon="nm-lock"/>
        </template>
        <template v-slot:append>
          <NamaIcon class="tw-cursor-pointer nama-auth-reveal"
                    role="button"
                    @click="canShowPassword = !canShowPassword"
                    :default-icon="canShowPassword?'visibility':'visibility_off'"/>
        </template>
      </q-input>
      <q-input
        input-class="nama-input-class"
        outlined
        dense
        class="nama-auth-input nama-focused-input nama-field-input tw-mb-5"
        v-model="reTypePassword"
        :type="canShowPassword?'text':'password'"
        :placeholder="Translator.translateId('confirmNewPassword')"
        :error-message="reTypePasswordValidationError"
        :hide-bottom-space="true"
        autocomplete="off"
        @keyup.enter="onEnterDown"
        ref="reTypePasswordRef">
        <template v-slot:prepend>
          <NamaIcon default-icon="nm-lock"/>
        </template>
      </q-input>
      <ButtonInput class="nama-auth-cta" :text="Translator.translateId('Confirm')" @click="onContinueClick" @keydown.enter="onContinueClick"/>
    </div>
  </div>
</template>

<style scoped>

</style>
